import { AllFarms } from 'components/Portfolio/AllFarms'
import { AllPositions } from 'components/Portfolio/AllPositions'
import { FiltersBar } from 'components/Portfolio/FiltersBar'
import { PortfolioSummary } from 'components/Portfolio/PortfolioSummary'
import { Staking } from 'components/Portfolio/Staking'
import { TokenHoldings } from 'components/Portfolio/TokenHoldings'
import { V2Positions } from 'components/Portfolio/V2Positions'
import { V3Positions } from 'components/Portfolio/V3Positions'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

const Section = styled.div`
  scroll-margin-top: 140px;
`

export default function Portfolio() {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1)
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 300)
    }
  }, [location.hash])

  return (
    <div className="self-stretch w-full max-w-7xl mx-auto flex flex-col gap-7 sm:gap-8">
      <div className="flex flex-col gap-3 sm:gap-6">
        <PortfolioSummary />
        <FiltersBar />
        <Section id="tokens">
          <TokenHoldings />
        </Section>
      </div>
      <Section id="top-pools">
        <AllPositions />
      </Section>
      <Section id="v3">
        <V3Positions />
      </Section>
      <Section id="v2">
        <V2Positions />
      </Section>
      <Section id="farms">
        <AllFarms />
      </Section>
      <Section id="staking">
        <Staking />
      </Section>
    </div>
  )
}
